/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".container-info[_ngcontent-%COMP%]{background:rgba(255,255,255,.95);box-shadow:0 1px 4px 0 rgba(0,0,0,.5);border-radius:8px;position:absolute;z-index:100;top:50%;left:50%;transform:translateX(-50%) translateY(-50%)}.container-info-text[_ngcontent-%COMP%]{overflow-y:auto;height:200px;width:350px;padding:5px;font-family:ROBOTO;font-size:small;color:#4e4e4e}.container-info-close-button[_ngcontent-%COMP%]{position:absolute;top:0;right:0}.container-hidden[_ngcontent-%COMP%]{display:none}"];
export { styles as styles };
